export const theme = {
    primaryColor: "#A0C63D",
    colors: {
        error: "#CF4948"
    }
};
